const KYC_TOKEN_PARAM_PATTERN = /(^|[?&])kycToken=[^&#]*(&)?/g;

export const stripKycTokenParam = (value: string): string =>
  value.replace(KYC_TOKEN_PARAM_PATTERN, (_match, separator: string, nextParam?: string) => (nextParam ? separator : ''));
